import { useQuery } from "@tanstack/react-query";
import { api } from "utils/api";

export interface PropertyForTheCompanyModel {
    id: number;
    name: string;
    address: string;
    entity?: string | null;
}

const fetchPropertiesForTheCompany = async (
    companyId: string | null | undefined,
    entityId?: string | null
): Promise<PropertyForTheCompanyModel[]> => {
    if (!companyId) {
        return [];
    }

    const { data } = await api.get<PropertyForTheCompanyModel[]>(
        `/companies/${companyId}/properties`,
        {
            params: {
                entityId,
            },
        }
    );

    return data;
};

export function usePropertiesForTheCompany(
    companyId: string | null | undefined,
    entityId?: string | null
) {
    return useQuery({
        queryKey: ["properties", companyId, entityId],
        queryFn: () => fetchPropertiesForTheCompany(companyId, entityId),
        enabled: !!companyId,
    });
}
